<template>
	<div class="container-fluid bg-gray-30 rounded mb-4">
		<div class="row py-4">
			<div class="col-12 col-md-6">
				<h6 class="font-weight-normal">{{__('lang.kwl.building_data.building_type')}}</h6>
				<p class="text-gray-60 border-gray-50 border-bottom pb-2">{{ getLangKey('building_type', building.type).text}}</p>
			</div>
			<div class="col-12 col-md-6">
				<h6 class="font-weight-normal">{{__('lang.kwl.building_data.location')}}</h6>
				<p class="text-gray-60 border-gray-50 border-bottom pb-2">{{ getLangKey('building_location', building.location).text }}</p>
			</div>
			<div class="col-12 col-md-6">
				<h6 class="font-weight-normal">{{__('lang.kwl.building_data.airtightness')}}</h6>
				<p class="text-gray-60 border-gray-50 border-bottom pb-2">{{ getLangKey('building_airtightness', building.airtightness).text }}</p>
			</div>
			<div class="col-12 col-md-6">
				<h6 class="font-weight-normal">{{__('lang.kwl.building_data.heat_protection')}}</h6>
				<p class="text-gray-60 border-gray-50 border-bottom pb-2">{{ building_heat_protection_options.text }}</p>
			</div>
			<div class="col-12 col-md-6">
				<h6 class="font-weight-normal">{{__('lang.kwl.building_data.occupancy')}}</h6>
				<p class="text-gray-60 border-gray-50 border-bottom pb-2">{{building_occupancy_options.text}}</p>
			</div>
			<div class="col-12 py-3 text-center">
				<button class="btn btn-primary" @click="setData()">{{__('lang.kwl.building_data.adjust_values')}}</button>
			</div>
		</div>
	</div>
</template>
<script>
import Building from '@models/building/Building'
import Unit from '@models/building/Unit'

import { setLabels, getLangKey } from '@services/helpers/langHandler'
import log from '@services/logger/index'

export default {
data() {
		return {
		}
	},
	methods: {
		setData() {
			this.$store.dispatch('modalSettings/setComponent', 'BuildingData');
			this.$store.dispatch('modalSettings/isLarge', true);
			this.$store.dispatch('modalSettings/callRef');
			this.$store.dispatch('modalSettings/open');
		},
		getLangKey: getLangKey,
		setLabels: setLabels,
	},
	computed: {
		building() {
			return Building.query().first();
		},
		unit() {
			return Unit.query().first();
		},
		building_heat_protection_options: {
			get () {
				var options = this.setLabels(this.$store.state.inputs.building_heat_protection);
				return options.find(e => e.value == this.building.heatProtection);
			}
		},
		building_occupancy_options: {
			get () {
				var options = this.setLabels(this.$store.state.inputs.building_occupancy);
				return options.find(e => e.value == this.unit.occupancy);
			}
		},
	},
}
</script>